import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { BASE_API_URL } from '../const/environments.constants';
import i18n from '../plugins/i18n';

const getBaseUrl = (): string => BASE_API_URL || '';

const API = axios.create({
    baseURL: getBaseUrl(),
});

API.interceptors.request.use((req: InternalAxiosRequestConfig) => {
    req.headers['Content-Type'] = 'application/json';
    req.headers['content-language'] = i18n.language || 'es';
    req.headers.utcoffset = '-300';

    return req;
});

API.interceptors.response.use(
    (response: AxiosResponse) => response.data,
    (error: AxiosError) => Promise.reject(error.response?.data),
);

export { API, getBaseUrl };
